import { render, staticRenderFns } from "./BaseNotificationItemWrapperParts.vue?vue&type=template&id=901789aa&scoped=true"
import script from "./BaseNotificationItemWrapperParts.vue?vue&type=script&lang=ts"
export * from "./BaseNotificationItemWrapperParts.vue?vue&type=script&lang=ts"
import style0 from "./BaseNotificationItemWrapperParts.vue?vue&type=style&index=0&id=901789aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901789aa",
  null
  
)

export default component.exports